const enumeratedData = {
  picSourceOptions: [
    {value:'1', label: '手动上传'}
  ],
  picSourceObj: {
    '1':'手动上传',
    '2':'手动引用',
    '3':'自动引用',
  }
};
export default enumeratedData;
//  {value:'2', label: '手动引用'},
//     {value:'3', label: '自动引用'},
